import { Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { LegacyToDashboardRedirect } from '../components/LegacyToDashboardRedirect';

/**
 * Suite routes — legacy paths at `/` redirect to the dashboard app at `/dashboard/*`.
 * Business features live in apps/dashboard; frontend only hosts auth, signup, KDS, and redirects.
 */
export const suiteRoutes = (
  <>
    <Route path="/accounts-suite/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/accounts-suite" replace />
      </ProtectedRoute>
    } />

    <Route path="/employee-suite/*" element={
      <ProtectedRoute>
        <LegacyToDashboardRedirect />
      </ProtectedRoute>
    } />

    <Route path="/settings-suite/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />

    <Route path="/marketing-hub-suite/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />

    <Route path="/retail-suite/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard/retail-suite" replace />
      </ProtectedRoute>
    } />

    <Route path="/dry-cleaning-suite/*" element={
      <ProtectedRoute>
        <LegacyToDashboardRedirect />
      </ProtectedRoute>
    } />

    <Route path="/laundry-suite/*" element={
      <ProtectedRoute>
        <LegacyToDashboardRedirect />
      </ProtectedRoute>
    } />

    <Route path="/labels-suite/*" element={
      <ProtectedRoute>
        <Navigate to="/dashboard" replace />
      </ProtectedRoute>
    } />
  </>
);
